const whenWindowLoaded = () =>
  new Promise(resolve => {
    if (document.readyState === 'complete') {
      resolve();
    }

    window.addEventListener('load', () => {
      resolve();
    });
  });

export default whenWindowLoaded;
